export default "__VITE_ASSET__7a948cc0__"